// To be kept in sync with https://git.hubteam.com/HubSpot/IdentityBase/blob/4ca4df7afe02596f75d07922ff1b6f9d2c41d38b/src/main/protobuf/contacts.proto#L174
// (link is to commit as of 1/21/2021, check file at latest master for updates)

export const STRING = 'string';
export const NUMBER = 'number';
export const BOOLEAN = 'bool';
export const DATE_TIME = 'datetime';
export const ENUMERATION = 'enumeration';
export const DATE = 'date';
// export const PHONE_NUMBER = 'phone_number';
// export const CURRENCY_NUMBER = 'currency_number';
// export const JSON_TYPE = 'json';
// export const OBJECT_COORDINATES = 'object_coordinates';
// | typeof PHONE_NUMBER
// | typeof CURRENCY_NUMBER
// | typeof JSON_TYPE
// | typeof OBJECT_COORDINATES;